'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  addLayer: _propTypes2.default.func.isRequired,
  removeLayer: _propTypes2.default.func.isRequired
});


//////////////////
// WEBPACK FOOTER
// ../~/react-leaflet/lib/propTypes/layerContainer.js
// module id = 1412
// module chunks = 2